export const SET_ROOMS = 'SET_ROOMS';
export const GET_ROOMS = 'GET_ROOMS';
export const HANDLE_CHANGE = 'HANDLE_CHANGE';
export const FILTER_ROOMS = 'FILTER_ROOMS';